var _defs, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d4b35f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.23,577.35c-66.62,0-120.82-54.2-120.82-120.82s54.2-120.82,120.82-120.82,120.82,54.2,120.82,120.82-54.2,120.82-120.82,120.82ZM430.23,345.71c-61.11,0-110.82,49.71-110.82,110.82s49.71,110.82,110.82,110.82,110.82-49.71,110.82-110.82-49.71-110.82-110.82-110.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.14,502.69c-2.76,0-5-2.24-5-5v-55.16c0-21.65,17.61-39.26,39.26-39.26,9.72,0,19.05,3.58,26.27,10.08,2.05,1.85,2.22,5.01.37,7.06-1.85,2.05-5.01,2.22-7.06.37-5.38-4.84-12.33-7.51-19.58-7.51-16.13,0-29.26,13.13-29.26,29.26v55.16c0,2.76-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.24,464.18h-67.32c-2.76,0-5-2.24-5-5s2.24-5,5-5h67.32c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M462.32,504.04h-74.4c-2.76,0-5-2.24-5-5s2.24-5,5-5h74.4c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M490.25,153.28h-120.63c-2.76,0-5-2.24-5-5V27.65c0-2.76,2.24-5,5-5s5,2.24,5,5v115.63h115.63c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.23,577.35H53.95c-2.76,0-5-2.24-5-5V27.65c0-2.76,2.24-5,5-5h315.67c1.33,0,2.6.53,3.54,1.46l120.63,120.63c.94.94,1.46,2.21,1.46,3.54v201.48c0,2.76-2.24,5-5,5s-5-2.24-5-5v-199.41l-117.7-117.7H58.95v534.7h371.28c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.73,224.55H110.47c-2.76,0-5-2.24-5-5s2.24-5,5-5h323.26c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.69,158.76H110.47c-2.76,0-5-2.24-5-5s2.24-5,5-5h208.22c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.69,92.96H110.47c-2.76,0-5-2.24-5-5s2.24-5,5-5h208.22c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.73,290.34H110.47c-2.76,0-5-2.24-5-5s2.24-5,5-5h323.26c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.61,356.13H110.47c-2.76,0-5-2.24-5-5s2.24-5,5-5h173.14c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.35,421.92h-121.88c-2.76,0-5-2.24-5-5s2.24-5,5-5h121.88c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.56,525.25c-21.77,0-31.01-11.47-39.97-22.6-7.28-9.04-14.15-17.57-28.21-21.59-8.17-2.33-15.23-1.69-21.57,1.96-14.14,8.14-19.44,28.56-19.49,28.76-.68,2.67-3.39,4.3-6.07,3.63-2.67-.67-4.3-3.38-3.63-6.06.25-1,6.33-24.67,24.15-34.97,8.7-5.03,18.58-6.02,29.36-2.94,17.11,4.89,25.69,15.54,33.26,24.93,9.47,11.76,16.95,21.04,39.39,18.43,2.74-.33,5.22,1.64,5.55,4.39.32,2.74-1.64,5.23-4.39,5.54-2.98.35-5.76.51-8.36.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxIcon);
export default __webpack_public_path__ + "static/media/TaxIcon.e8ec40699b4e0ea6addf6283298310ad.svg";
export { ForwardRef as ReactComponent };